export default __webpack_public_path__ + "static/media/i066vp.7bc7a059.webp";